import ExamsFilterRouteView from "@features/exam/components/ExamsFilterRouteView";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
/* -----------------UI--------------- */
import { Dialog as PaperDialog } from "react-native-paper";

type Props = {
	visible: boolean;
	handleClose?: () => void;
	postExamContextSwitchCallback?: (newExamId: string) => void;
};
export const ExamsFilterDialog = ({
	visible,
	handleClose,
	postExamContextSwitchCallback,
}: Props) => {
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			showCloseButton={false}
		>
			<PaperDialog.Content
				style={{
					flex: 1,
					paddingBottom: 0,
					paddingHorizontal: 0,
					marginTop: 0,
				}}
			>
				<ExamsFilterRouteView
					handleClose={handleClose}
					searchBarProps={{ icon: "magnify" }}
					postExamContextSwitchCallback={postExamContextSwitchCallback}
				/>
			</PaperDialog.Content>
		</DialogWrapper>
	);
};
